<template>
  <div :class="$style[classes]">
    <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber"
      :page-size="pageSize" ref="table" isAddPageToRouter :isOutside="isOutside">
          <wt-table :list="tableData" @select="toSelect" @select-all="selectAll" :is-select="isSelect" :labels="tableLabels" v-loading="loading">
            <slot/>
          </wt-table>
    </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
import { notesLabels, parseNotesLabels, notesOfQuestionLabels, LifeExperienceHallnotesLabels, notesOfQuestionInReportLabels, twentyAnniversaryLabels, twentySurveyLabels } from '../active-sign-notes'
const prefixCls = 'pt-notes-table'
export default {
  name: 'pt-notes-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    tableLabels () {
      // 先判断是不是20周年活动
      if (this.isTwentyAnniversary) {
        return twentyAnniversaryLabels
      }
      if (this.isTwentiethSurvey) {
        return twentySurveyLabels
      }
      return this.isQuestion ? (this.isReportQuestion ? notesOfQuestionInReportLabels : notesOfQuestionLabels) : (this.isParse ? parseNotesLabels : (this.isLifeExperienceHall ? LifeExperienceHallnotesLabels : notesLabels))
    },
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    totalNumber: {
      type: Number
    },
    pageSize: {
      type: Number,
      default: 10
    },
    isOutside: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array
    },
    loading: {
      type: Boolean
    },
    isParse: {
      type: Boolean
    },
    isQuestion: {
      type: Boolean
    },
    isReportQuestion: {
      type: Boolean
    },
    isLifeExperienceHall: {
      type: Boolean
    },
    isSelect: {
      type: Boolean,
      default: false
    },
    isTwentyAnniversary: {
      type: Boolean,
      default: false
    },
    isTwentiethSurvey: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  methods: {
    toSelect (selection) {
      this.$emit('chooseRecord', selection)
    },
    selectAll (selection) {
      this.$emit('chooseRecord', selection)
    },
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next) {
      this.$emit('getTableData', page, next)
    },
    showReTry () {
      this.$refs.table.showReTry()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-notes-table{
  :global{
    .el-button{
      margin-left: 0;
      margin-right: 10px;
    }
  }
}
</style>
